import React from 'react';
import { theme } from '../../theme';

// Sticky form header — Swipe pattern. The "← Back" + title sits left, the
// primary save action sits right and stays visible while the user scrolls
// through long forms (Create Invoice, etc.).
//
// Props:
//   onBack    optional () => void — renders a chevron back button
//   title     main page/form title
//   subtitle  small grey line under title (e.g. company name, doc number)
//   left      optional ReactNode rendered after the title (e.g. doc-# input)
//   right     ReactNode (typically a row of buttons)
export default function StickyTopBar({ onBack, title, subtitle, left, right }) {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 50,
      backgroundColor: theme.surface,
      borderBottom: `1px solid ${theme.border}`,
      boxShadow: theme.stickyShadow,
      padding: '12px 18px',
      marginBottom: '14px',
      borderRadius: '0 0 12px 12px',
      display: 'flex', alignItems: 'center', gap: '14px',
    }}>
      {onBack && (
        <button
          onClick={onBack}
          style={{
            background: 'transparent', border: 'none', cursor: 'pointer',
            padding: '6px', borderRadius: '6px', color: theme.navy,
            display: 'flex', alignItems: 'center',
          }}
          title="Back"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
      )}
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '12px' }}>
        <div>
          <h2 style={{ margin: 0, color: theme.navy, fontSize: '1.15rem', fontWeight: '700' }}>{title}</h2>
          {subtitle && <div style={{ fontSize: '0.74rem', color: theme.textMuted, marginTop: '2px', textTransform: 'uppercase', letterSpacing: '0.04em', fontWeight: '600' }}>{subtitle}</div>}
        </div>
        {left}
      </div>
      <div style={{ flex: 1 }}/>
      {right && <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>{right}</div>}
    </div>
  );
}
